import { render, staticRenderFns } from "./report-student-grade-component.vue?vue&type=template&id=933c8eb8&scoped=true&"
import script from "./report-student-grade-component.vue?vue&type=script&lang=js&"
export * from "./report-student-grade-component.vue?vue&type=script&lang=js&"
import style0 from "./report-student-grade-component.vue?vue&type=style&index=0&id=933c8eb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "933c8eb8",
  null
  
)

export default component.exports